import { URL_PAGE_CGV } from "@middleware/constants";

export const prismicRoutes = [
  {
    type: "page_cgv",
    path: URL_PAGE_CGV,
  },
];
